











import Vue from "vue";

export default Vue.extend({
  props: ['isActive', 'icon', 'label'],
});
